import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'user-personal-info-desktop',
    templateUrl: './personal-info-desktop.component.html',
    styleUrls: ['./personal-info-desktop.component.scss'],
    standalone: false
})
export class PersonalInfoDesktopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
